import React, { useState, useRef, useEffect, useContext } from 'react'
import { isNewHomePageApplicable } from '../../constants/feature';
import { useClearRefinements, useRefinementList } from 'react-instantsearch-hooks-web';
import isNull from 'lodash/isNull';
import appContext from '../../Context/appContext';
import ListFilterItem from './ListFilterItem';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedPriceSort } from '../../redux/slices/searchSlice';

const DesktopFilter = ({ deviceType, shadowHeight, className = '', children, setListLoading, listLoading }) => {

  const [filterHolderWidth, setfilterHolderWidth] = useState(0);
  const [open, setOpen] = useState(null);
  const [addShadow, setAddShadow] = useState(false);

  const filterHolder = useRef(null);

  const handleOpen = (index) => {
    if (open === index) return setOpen(null)
    return setOpen(index)
  };

  useEffect(() => {
    setfilterHolderWidth(filterHolder.current.clientWidth);
  }, [listLoading]);

  const scrollToFilter = () => {
    let header = document.getElementsByClassName('bento-header')[0]
    let filter = document.getElementsByClassName("desktop-filter-container")[0]
    if (filter?.getBoundingClientRect().top > header?.clientHeight) {
      if (filter?.getBoundingClientRect().top - 37 - 20 > header?.clientHeight) return // 37px is advert header height & 20px is buffer
    };

    var element = document.getElementById('list-top');
    var headerOffset = (header?.clientHeight + filter?.clientHeight) || 150;
    var elementPosition = element?.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
    });
  };

  const handleScroll = () => {
    if ((window.pageYOffset > shadowHeight)) {
      setAddShadow(true)
    } else {
      setAddShadow(false)
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handlePopup = (e) => {
    const parent = document.getElementsByClassName('desktop-filters')[0]
    const child = e.target.parentElement;

    if (child?.id === "popup-open-btn" || child?.id === "popup-open-btn-icon") return
    if (!JSON.parse(localStorage.getItem("isPopupOpen"))) return
    if (child?.className?.split(" ").includes("custom-checkbox")) return;
    if (parent?.contains(child)) return;
    setOpen(null)
  }

  useEffect(() => {
    window.addEventListener('click', handlePopup);
    return () => {
      window.removeEventListener('click', handlePopup);
    }
  }, [])


  useEffect(() => {
    localStorage.setItem("isPopupOpen", !isNull(open))
  }, [open]);


  // const {
  //   // state: {
  //   //   search: { selectedPriceSort }
  //   // },
  //   dispatch
  // } = useContext(appContext);
  const selectedPriceSort = useSelector(state => state.search.selectedPriceSort)
  const dispatchRedux = useDispatch()

  const { refine, canRefine } = useClearRefinements({
    includedAttributes: ['brands', 'full_shop_categories', 'strain', 'deviceType']
  });

  const { items: strainItems } = useRefinementList({ attribute: 'strain', limit: 30 });
  const { items: brandItems } = useRefinementList({ attribute: 'brands', limit: 30 });
  const { items: categoryItems } = useRefinementList({ attribute: 'full_shop_categories', limit: 30 });
  const { items: deviceTypeItems } = useRefinementList({ attribute: 'deviceType', limit: 30 });

  const refinedStrainItems = strainItems.filter(item => item?.isRefined == true)?.length ?
    ` (${strainItems.filter(item => item?.isRefined == true)?.length})` : '';

  const refinedBrandItems = brandItems.filter(item => item?.isRefined == true)?.length ?
    ` (${brandItems.filter(item => item?.isRefined == true)?.length})` : '';

  const refinedCategoryItems = categoryItems.filter(item => item?.isRefined == true)?.length ?
    ` (${categoryItems.filter(item => item?.isRefined == true)?.length})` : '';

  const refinedDeviceTypeItems = deviceTypeItems.filter(item => item?.isRefined == true)?.length ?
    ` (${deviceTypeItems.filter(item => item?.isRefined == true)?.length})` : '';

  let filterList = [{
    title: "Sort", countLabel: '', attribute: 'sort', filterType: 'sort', type: 'radio'
  }];

  if (categoryItems?.length) {
    filterList.push({ title: `Categories`, countLabel: `${refinedCategoryItems}`, attribute: 'full_shop_categories', filterType: 'search', type: 'checkbox' })
  }
  if (brandItems?.length) {
    filterList.push({ title: `Brands`, countLabel: `${refinedBrandItems}`, attribute: 'brands', filterType: 'search', type: 'checkbox' })
  }
  if (strainItems?.length) {
    filterList.push({ title: `Strain Types`, countLabel: `${refinedStrainItems}`, attribute: 'strain', filterType: 'search', type: 'checkbox' })
  }
  if (deviceTypeItems?.length) {
    filterList.push({ title: `Device Types`, countLabel: `${refinedDeviceTypeItems}`, attribute: 'deviceType', filterType: 'search', type: 'checkbox' })
  }


  const clearFilters = () => {
    window.scrollTo(0, 0);
    setListLoading(true);
    refine();
    // dispatch({ type: 'setSelectedPriceSort', payload: '' });
    dispatchRedux(setSelectedPriceSort(''))
    setOpen(null);
    //scrollToFilter();
    setTimeout(() => setListLoading(false), 500);
  };


  return (
    <div className={`desktop-filter-container mt-3 hide-for-drinkcann hide-for-kiva hide-for-plus-products hide-for-zenodose ${className} ${isNewHomePageApplicable ? "extra-sticky" : ""} ${isNewHomePageApplicable && addShadow ? "sticky-filter-shadow" : ""}`} style={{ '--filter-holder-width': filterHolderWidth + 'px' }} key='desktop-filter-container'>
      <div className='d-inline-flex align-items-center justify-content-center text-left filters-holder' ref={filterHolder}>
        <h5 className="bold mb-0 d-none">
          Filters
        </h5>
        <div className="desktop-filters d-flex" >
          <>
            {filterList.map((item, index) => {

              return (
                <CollapsibleFilter
                  item={item}
                  deviceType={deviceType}
                  // onChange={onChange}
                  handleOpen={() => handleOpen(index)}
                  open={open === index}
                  setListLoading={setListLoading}
                />
              )
            })}
            <button disabled={!selectedPriceSort && !canRefine} type="button" className="btn btn-link clear-btn semi-bold ml-2" onClick={clearFilters}>
              Clear All
            </button>
          </>
        </div>
        {children}
      </div>
    </div>
  )
}

const CollapsibleFilter = ({ item, open, handleOpen, setListLoading }) => {
  const { title, countLabel } = item;


  return (
    <div className="filters-block">
      <div
        id="popup-open-btn"
        onClick={handleOpen}
        className='d-flex align-items-center justify-content-between'
        style={{ cursor: "pointer" }}
      >
        <div className="mr-3">
          {title}
          <span>{countLabel}</span>
        </div>
        <i id='popup-open-btn-icon' className={open ? 'icon-down flip' : 'icon-down '} />
      </div>
      <div className={`${open ? '' : 'd-none'}`}>
        <ListFilterItem
          filter={item}
          setListLoading={setListLoading}
        />
      </div>
    </div>
  )
}

export default DesktopFilter